import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "k-colour-code row justify-start items-center gap-12 full-width" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import { ref, watch } from 'vue'
import _ from 'lodash'

interface IProps {
  maxSize?: number
  hasInput?: boolean
  hasTransparency?: boolean
  hasNoColor?: boolean
  fallbackColour?: string | null
  defaultColours?: string[]
  canCustomizeColour?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KColourCode' },
  __name: 'KColourCode',
  props: /*@__PURE__*/_mergeModels({
    maxSize: { default: 19 },
    hasInput: { type: Boolean, default: true },
    hasTransparency: { type: Boolean, default: false },
    hasNoColor: { type: Boolean, default: true },
    fallbackColour: { default: null },
    defaultColours: { default: () => ['#F99500', '#F2BD00', '#98E000', '#12D48E', '#1361D4', '#D92AB2', '#652EDA', '#F4422A'] },
    canCustomizeColour: { type: Boolean, default: true }
  }, {
    "modelValue": { default: '#F99500' },
    "modelModifiers": {},
    "colours": { default: () => [] },
    "coloursModifiers": {},
  }),
  emits: ["update:modelValue", "update:colours"],
  setup(__props: any) {



const modelValue = _useModel<string | null>(__props, "modelValue")
const colours = _useModel<string[]>(__props, 'colours')

const props = __props

const defaultColoursRef = ref([...props.defaultColours])

const isColourSelectedRef = ref(false)
const addNewColourRef = ref(false)

const defaultValuesAmount = props.defaultColours.length
const lastIndexDefaultColors = props.defaultColours.length - 1

watch(modelValue, (newValue) => {
  if (newValue === null) return
  let colorCode = newValue
  if (!props.hasTransparency && colorCode.length > 7) colorCode = colorCode.slice(0, -2)
  if (
    modelValue.value !== '' &&
    !isColourSelectedRef.value &&
    defaultColoursRef.value.length + 2 < props.maxSize &&
    !colours.value.includes(newValue)
  ) {
    defaultColoursRef.value.push(colorCode)
    colours.value = JSON.parse(JSON.stringify(defaultColoursRef.value)).splice(defaultValuesAmount)
  }
  isColourSelectedRef.value = false
  modelValue.value = colorCode
})

const defaultColours = JSON.parse(JSON.stringify(defaultColoursRef.value))
const coloursClone = Array.from(new Set([...defaultColours, ...colours.value]))
const coloursSet = new Set()
coloursClone.forEach((colour) => {
  coloursSet.add(colour)
})

let colour = modelValue.value || ''
if (colour && !colour.startsWith('#')) colour = `#${colour}`
if (colour && !coloursSet.has(colour)) coloursClone.push(colour)
defaultColoursRef.value = coloursClone

function manageColour(colour: string | null) {
  if (colour === null) return
  isColourSelectedRef.value = true
  modelValue.value = colour
  colours.value = _.cloneDeep(defaultColoursRef.value).splice(defaultValuesAmount)
}

function removeColour(colour: string, index: number) {
  defaultColoursRef.value.splice(index, 1)
  colours.value = _.cloneDeep(defaultColoursRef.value).splice(defaultValuesAmount)
  if (colour === modelValue.value) modelValue.value = ''
}

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_KTooltip = _resolveComponent("KTooltip")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_KColourPicker = _resolveComponent("KColourPicker")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.canCustomizeColour)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_KIcon, {
            class: "cursor-pointer",
            name: "colours",
            size: "32px",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (addNewColourRef.value = true), ["prevent"]))
          }),
          _createVNode(_component_KTooltip, {
            label: "Custom Colour",
            "text-color": "white"
          })
        ]))
      : _createCommentVNode("v-if", true),
    (__props.hasNoColor)
      ? (_openBlock(), _createBlock(_component_k_icon, {
          key: 1,
          class: "cursor-pointer",
          name: "stop",
          size: "32px",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (manageColour('')))
        }))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultColoursRef.value, (defaultColour, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["k-colour-code__circles row justify-center items-center rounded-circle bg-cool-gray-30 q-pa-xs relative-position cursor-pointer transition", {
        'k-colour-code--selected-border': modelValue.value === defaultColour,
      }]),
        style: _normalizeStyle({ color: defaultColour }),
        onClick: ($event: any) => (manageColour(defaultColour))
      }, [
        (index > lastIndexDefaultColors)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "k-colour-code__remove-colour absolute row justify-center items-center rounded-circle",
              onClick: _withModifiers(($event: any) => (removeColour(defaultColour, index)), ["stop"])
            }, [
              _createVNode(_component_k_icon, {
                name: "remove",
                size: "12px"
              })
            ], 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "full-width full-height k-colour-code__box rounded-circle" }, null, -1 /* CACHED */))
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_3))
    }), 128 /* KEYED_FRAGMENT */)),
    (__props.fallbackColour !== null)
      ? (_openBlock(), _createBlock(_component_k_icon, {
          key: 2,
          class: "cursor-pointer",
          name: "refresh",
          size: "16px",
          color: "cool-gray-100",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (manageColour(__props.fallbackColour)))
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_q_dialog, {
      modelValue: addNewColourRef.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addNewColourRef).value = $event)),
      "max-height": "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_KColourPicker, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue).value = $event)),
          "has-input": __props.hasInput,
          "has-transparency": __props.hasTransparency,
          class: "custom-scrollbar",
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (addNewColourRef.value = false))
        }, null, 8 /* PROPS */, ["modelValue", "has-input", "has-transparency"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})